import { useContext, useEffect, useState } from "react";
import Game from "../../store/Game";
import useCurrentGame from "../../hooks/useCurrentGame";
import { SOCKET_EVENTS, SocketContext } from "../../components/SocketProvider";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import PersonalAccount from "../../store/PersonalAccount";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../utils/routes";

export default function useController() {
  const { socket } = useContext(SocketContext);
  const navigate = useNavigate();
  const { getCurrentGame } = useCurrentGame();
  const [isEnd, setIsEnd] = useState(false);
  const { getUserData } = useCurrentUserData();
  const { token } = useAuth();
  const game = Game.game;

  const onNext = async () => {
    await PersonalAccount.getPersonalAccountData();
    if (!PersonalAccount.user.gameIdsByRules.includes(game.id)) {
      navigate(ROUTES.ACCEPT_RULES_PAGE);
      return;
    }
    navigate(ROUTES.MATCHES_PAGE);
  };

  useEffect(() => {
    if (!game.invitedUserId && token && game.link) {
      navigate(ROUTES.LINK_WAS_NOT_SENT_PAGE);
    }
  }, [game]);
    
  const handler = (response) => {
    const user = getUserData();

    if (response.senderId !== user?.id) setIsEnd(response.isEnd);
  };

  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.END_GAME_MESSAGE, handler);
    return () => {
      socket.current.off(SOCKET_EVENTS.END_GAME_MESSAGE, handler);
    };
  }, [socket]);

  useEffect(() => {
    const game = getCurrentGame();
    if (game) {
      Game.getZones(game.id);
    }
  }, [isEnd]);

  return {
    onNext,
  };
}
